<template>
  <Tag
    v-for="(company, index) in companiesForDisplay"
    :key="'acc_' + index"
    class="mr-1 my-1"
  >
    {{ getDisplayLabel(company) }}
  </Tag>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { CompanyJson } from '@/data/companies/CompanyJson.ts';

export default {
  name: 'AttachedCompaniesCell',
  props: {
    companies: { type: Array as PropType<CompanyJson[]>, required: true },
    userCompanyId: { required: true, type: Number },
  },
  computed: {
    companiesForDisplay(): CompanyJson[] {
      if (!this.companies) {
        return [];
      }

      return this.companies.filter((c) => c.id !== this.userCompanyId);
    },
  },
  methods: {
    getDisplayLabel(company) {
      return company.name + (company.is_owner ? ' (owner)' : '');
    },
  },
};
</script>

<style scoped></style>
